export enum Variant {
  SET_INITIAL = 'setInitial',
  SET_VARIANT = 'setVariant',
  SET_ADD_CART_ERROR = 'setCartError',
}
